import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import SignatureBlockConfigurationPage from "./SignatureBlockConfigurationPage";
import { getAllDealLegalEntityInvestmentsForDeal } from "../../../api/deals/investors";
import * as api from "../../../api/generated-api";
import { UserWithPersonWithOrganizationPersons } from "../../../api/types";

type Props = {
  token: string;
  orgId: number;
  dealId: number;
  dealLegalEntityInvestmentId: number;
};

const SignatureBlockConfigurationForInvestmentRouter = ({
  token,
  orgId,
  dealId,
  dealLegalEntityInvestmentId,
}: Props) => {
  const [dealLegalEntityInvestment, setDealLegalEntityInvestment] =
    useState<api.DealLegalEntityInvestment>();

  useEffect(() => {
    getAllDealLegalEntityInvestmentsForDeal(
      orgId,
      dealId,
      (dealLegalEntityInvestments) => {
        const dealLegalEntityInvestment = dealLegalEntityInvestments.find(
          (dealLegalEntityInvestment) =>
            dealLegalEntityInvestment.id === dealLegalEntityInvestmentId
        );

        setDealLegalEntityInvestment(dealLegalEntityInvestment);
      }
    );
  }, [token, orgId, dealId, dealLegalEntityInvestmentId]);

  if (!dealLegalEntityInvestment) {
    return null;
  }

  return (
    <SignatureBlockConfigurationPage
      token={token}
      orgId={orgId}
      dealId={dealId}
      dealLegalEntityId={dealLegalEntityInvestment.signer.id}
      dealLegalEntityInvestmentId={dealLegalEntityInvestmentId}
    />
  );
};

const mapStateToProps = (
  state: {
    auth: { user: UserWithPersonWithOrganizationPersons; token: string };
  },
  props: {
    match: {
      params: {
        dealId: string;
        orgId: string;
        dealLegalEntityInvestmentId: string;
      };
    };
  }
) => {
  const {
    match: {
      params: { dealId, orgId, dealLegalEntityInvestmentId },
    },
  } = props;
  const { user, token } = state.auth;

  return {
    user,
    token,
    dealId: parseInt(dealId),
    orgId: parseInt(orgId),
    dealLegalEntityInvestmentId: parseInt(dealLegalEntityInvestmentId),
  };
};

export default connect(mapStateToProps)(
  SignatureBlockConfigurationForInvestmentRouter
);
